(async () => {
    const baseComponent = await import(window.theme.modules.baseComponent);
    customElements.define('slideshow-thumbnails', class extends baseComponent.default {
        elements = { items: '*[data-item]' };
        render() {
            this.addEventListener('click', e => {
                const item = e.target.closest('[data-item]');
                const index = this.$items.indexOf(item);
                if (index >= 0) this.slider?.slideTo(index);
            });
        }
        onSliderLoad(slider) {
            this.slider?.swiper?.off('slideChange', this.changeHandler);
            this.slider = slider;
            this.changeHandler = () => this._setActive(slider.swiper.realIndex ?? slider.swiper.activeIndex);
            slider.swiper.on('slideChange', this.changeHandler);
            this.changeHandler();
        }
        reRender() { if (this.slider && this.changeHandler) this.onSliderLoad(this.slider); }
        disconnectedCallback() {
            this.slider?.swiper?.off('slideChange', this.changeHandler);
            super.disconnectedCallback();
        }
        _setActive(index) {
            const next = this.$items[index];
            if (!next) return;
            this.$items.forEach(item => {
                item.classList.toggle('!active', item === next);
                item.setAttribute('aria-pressed', item === next ? 'true' : 'false');
            });
            this.active = next;
            if (this.hasAttribute('horizontal')) next.parentNode.scrollLeft = next.offsetLeft - 200;
            else next.parentNode.scrollTop = next.offsetTop - 200;
        }
    });
})();